module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray@2x-79a402f319fa2fd9c8f3999eba9ef167.png";